<div class="overlay-form">
    <img (click)="ref.close({ success: false })" [src]="IMAGE_URLS.closeIconDark" class="clickable close-btn" />

    <div class="overlay-content" #overlayContainer>
        @if (!showSignInFlow) { @if (!enterTop) { @if (!loginWithOtp) {
        <div class="authentication-container">
            <div class="header">
                <img (click)="changeLoginOption()" [src]="IMAGE_URLS.arrowLeftIcon" alt="back" />
                Login
            </div>

            <div class="body">
                <caption>
                    {{
            HTML_CONSTANTS.LOGIN_WITH_PASSWORD
          }}
                </caption>
                <form (keydown.enter)="login()" [formGroup]="loginForm">
                    <base-input [label]="HTML_CONSTANTS.ENTER_EMAIL_LABEL" [errorMessages]="{
              required: HTML_CONSTANTS.ENTER_EMAIL_REQUIRED_ERROR_MESSAGE,
              email: HTML_CONSTANTS.ENTER_EMAIL_PATTERN_ERROR_MESSAGE
            }" [placeholder]="HTML_CONSTANTS.ENTER_EMAIL_PLACEHOLDER" [control]="loginCredentialControl"></base-input>

                    <base-input type="password" label="Password" [control]="passwordControl" [errorMessages]="{
              required: 'Password Required',
              password: 'Please enter a valid password'
            }"></base-input>

                    @if (errorMessage) {
                    <p class="error-state-msg">
                        {{ errorMessage }}
                    </p>
                    }

                    <base-button-md class="selector-button" [loading]="buttonLoading" (buttonClicked)="login()">Login</base-button-md>
                    <span (click)="forgotPassword()" class="forget-password">Forgot Password?</span>
                </form>
            </div>
            <div class="footer">
                <p>Don't you have an account?</p>
                <p class="create-account" (click)="createAccount()">Create a New account</p>
            </div>
        </div>
        } @else {
        <div class="authentication-container">
            <div class="header">Login</div>

            <div class="body">
                <caption>
                    {{
            HTML_CONSTANTS.LOGIN_OTP_MESSAGE
          }}
                </caption>
                <form (keydown.enter)="requestOTP()">
                    <base-input [label]="HTML_CONSTANTS.ENTER_EMAIL_LABEL" [errorMessages]="{
              required: HTML_CONSTANTS.ENTER_EMAIL_REQUIRED_ERROR_MESSAGE,
              email: HTML_CONSTANTS.ENTER_EMAIL_PATTERN_ERROR_MESSAGE
            }" [placeholder]="HTML_CONSTANTS.ENTER_EMAIL_PLACEHOLDER" [control]="login_credential"></base-input>

                    <base-button-md class="selector-button" [loading]="buttonLoading" (click)="requestOTP()">Request OTP</base-button-md>
                    <span (click)="changeLoginOption()" class="forget-password">Login with Password</span>
                </form>
            </div>
            <div class="footer">
                <p>Don't you have an account?</p>
                <p class="create-account" (click)="createAccount()">Create a New account</p>
            </div>
        </div>
        } } @else {
        <div class="authentication-container">
            <div class="header">OTP verification</div>

            <div class="body">
                <caption>
                    {{
            HTML_CONSTANTS.LOGIN_OTP_MESSAGE
          }}
                </caption>
                <form (keydown.enter)="verifyOTP()">
                    <ng-otp-input class="selector-otp-input" (onInputChange)="onOtpChange($event)" [config]="OTP_CONFIG">
                    </ng-otp-input>

                    <base-button-md class="selector-button" [loading]="otpButtonLoading" (click)="verifyOTP()">Verify</base-button-md>
                </form>
            </div>
            <div class="footer">
                <p>Didn't receive the OTP?</p>
                <p class="create-account" (click)="resendOTP()">Resend</p>
            </div>
        </div>
        } }
        <!-- Create account -->
        @if (showSignInFlow) {
        <webstore-registration [email]="emailAddress ?? ''" (registrationComplete$)="completeRegistration()" (goToLogin$)="goToLogin()"></webstore-registration>
        }
    </div>
</div>